export default __webpack_public_path__ + "static/media/Schneider Electric.58998785.png";